import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, forwardRef, ViewChild } from '@angular/core';
import {
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import { Router } from '@angular/router';
import { _HttpClient } from '@delon/theme';
import { NzButtonComponent, NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectComponent, NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { SelectInstantBaseComponent } from 'src/app/shared-feature/components/select/selectInstant-base';
import { ViewItemComponent } from 'src/app/shared/components/view-item/view-item.component';

import { TariffCodeEditModalComponent } from './tariff-code-edit-modal/tariff-code-edit-modal.component';

@Component({
  selector: 'app-tariff-tax-code-select',
  templateUrl: './tariff-tax-code-select.component.html',
  standalone: true,
  styles: [
    `
      ::ng-deep .ant-select-item-option-content .special-option {
        text-align: center !important;
      }

      .tariff-select-container {
        position: relative;
        width: 100%;
      }

      ::ng-deep .add-new-button {
        color: #000000 !important;
        font-weight: 500 !important;
        width: 100% !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 2px !important;
        background-color: transparent !important;
        border: none !important;
      }

      ::ng-deep .add-new-button .anticon {
        color: #000000 !important;
      }

      ::ng-deep .dropdownSelect:not(:has(.ant-select-item-option-active))
        .ant-select-item-option:nth-child(2):not(.ant-select-item-option-active):not(.ant-select-item-option-selected):not(:hover) {
        background-color: #ffc000;
      }
      ::ng-deep .dropdownSelect
        .ant-select-item-option:first-child:last-child:not(.ant-select-item-option-active):not(.ant-select-item-option-selected):not(:hover) {
        background-color: #ffc000;
      }
    `
  ],
  imports: [
    CommonModule,
    NzInputModule,
    NzSelectModule,
    FormsModule,
    ReactiveFormsModule,
    ViewItemComponent,
    TariffCodeEditModalComponent,
    NzSpinModule,
    NzButtonComponent,
    NzIconModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TariffTaxCodeSelectComponent),
      multi: true
    }
  ]
})
export class TariffTaxCodeSelectComponent extends SelectInstantBaseComponent implements AfterViewInit {
  @ViewChild('selector') nzSelectComponent!: NzSelectComponent;
  @ViewChild(TariffCodeEditModalComponent)
  tariffCodeEditModal!: TariffCodeEditModalComponent;

  constructor(http: _HttpClient, cdr: ChangeDetectorRef, router: Router) {
    super(http, cdr, router);
    this.valueField = '';
  }

  ngAfterViewInit(): void {
    // Handle active item on init if needed
    if (this.nzSelectComponent) {
      // Any initialization logic for active item can be added here
    }
  }

  getUrl(searchValue: string): string {
    let url = `api/tariffcodes/lookup?$orderby=code asc&$top=50`;
    if (searchValue) {
      const searchStr = searchValue.replaceAll("'", "''");
      url = `${url}&$filter=(contains(code, '${encodeURIComponent(
        searchStr
      )}') or contains(description, '${encodeURIComponent(searchStr)}'))`;
    }
    return url;
  }

  override addNew(event?: Event) {
    // Prevent event propagation to avoid triggering option selection
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    const tariffCode = this.instantData;
    // Close the dropdown first
    if (this.selector) {
      this.selector.nzOpen = false;
    }
    
    // Use setTimeout to ensure the dropdown closes before opening the modal
    setTimeout(() => {
      this.tariffCodeEditModal.showNew({
        isActive: true,
        code: tariffCode
      });
    }, 100);
  }

  override jump(): string| undefined {
    return undefined;
  }

  override queryParam(): String {
    return 'code';
  }

  // onKeydown(event: any) {
  //   if (event.ctrlKey || event.metaKey) return;

  //   const key = `${event.key}`;
  //   if (key.length !== 1) return;

  //   const allow = (key >= '0' && key <= '9') || key === '.';
  //   if (!allow) {
  //     event.preventDefault();
  //   }
  // }

  onClick(e: any) {
    if (!window.getSelection()?.toString()) {
      e.select();
    }
  }

  selectTariffCode(data: any) {
    if (data) {
      if (data.id) {
        // Add the new tariff code to the list if it's not already there
        if (!this.list.find(item => item.id === data.id)) {
          this.list.unshift(data);
        }
        // Set the new tariff code as selected
        this.selected = data;
        this.value = data;
        // Notify parent component of the change
        this.onChange(data);
        this.selectedChange.emit(data);
        // Trigger change detection
        this.cdr.detectChanges();
      } else {
        this.http.post('api/tariffcodes/quickcreate', data).subscribe(res => {
          if (res) {
            // Add the new tariff code to the list if it's not already there
            if (!this.list.find(item => item.id === res.id)) {
              this.list.unshift(res);
            }
            // Set the new tariff code as selected
            this.selected = res;
            this.value = res;
            // Notify parent component of the change
            this.onChange(res);
            this.selectedChange.emit(res);
            // Trigger change detection
            this.cdr.detectChanges();
          }
        });
      }
    } else {
      this.valueChanged(null);
    }
  }
}
